import BaseComponent from '@/components/base';
import Style from '@/components/frequency-selector/style';
import { FontStyle } from '@/components/style';
import { addGlobalStylesToShadowRoot } from '@/components/global-styles';
import { frequencyUncheckedSvg } from './frequencyUncheckedImages';
import { frequencyCheckedSvg } from './frequencyCheckedImages';
import stagingPlanOptions from '@/components/frequency-selector/staging';

export default class FrequencySelector extends BaseComponent {
  static EXCLUDE_FREQUENCIES = [6, 1];
  static DEFAULT_FREQUENCY = 2;

  static get observedAttributes() {
    return ['show-recommendations'];
  }

  onConnect() {
    addGlobalStylesToShadowRoot(this.shadowRoot);
    this.shadowRoot.addEventListener('click', this.handleClick.bind(this));
    const urlParams = new URLSearchParams(window.location.search);
    this.isEditing = !!urlParams?.get('editing');
    this.selectedFrequency = null;
    this.frequencyStateElem = document.querySelector(
      `.${this.getAttribute('frequencyStateElemClass')}`
    );
    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver(
      this.frequencyObserverCallback.bind(this)
    );
    observer.observe(this.frequencyStateElem, config);

    this.updateAllProductsFrequency(`${this.defaultFrequency} Month(s)`);
  }

  render() {
    return `
      ${Style({ isMobile: this.isSmall })}
      ${FontStyle}
      <div
        ${
          this.isSmall
            ? `style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: anchor-center;
            "`
            : ''
        }
      >
          <div class="frequency-buttons-container">
          ${this.frequencyOptions
            .map((option) => {
              return `
              <div
                data-frequency-value="${option.value}"
                data-frequency-number="${option.frequency_number}"
                class="frequency-button
                  ${
                    (this.isEditing &&
                      this.selectedFrequency === option.value) ||
                    (!this.isEditing &&
                      option.frequency_number == this.defaultFrequency)
                      ? 'selected featured-option'
                      : ''
                  }
                "
              >
                ${
                  (this.isEditing && this.selectedFrequency === option.value) ||
                  (!this.isEditing &&
                    option.frequency_number == this.defaultFrequency)
                    ? `<div class="recommended-container recommended-frequency events-none">Most Popular</div>`
                    : ''
                }

                <div class="events-none content-wrapper" ${
                  this.isSmall ? 'style="margin-bottom: 10px"' : ''
                }>
                  ${
                    this.showRecommendations
                      ? `<div id="frequency-svg" class="events-none">
                      ${
                        (this.isEditing &&
                          this.selectedFrequency === option.value) ||
                        (!this.isEditing &&
                          option.frequency_number == this.defaultFrequency)
                          ? frequencyCheckedSvg(Number(option.frequency_number))
                          : frequencyUncheckedSvg(
                              Number(option.frequency_number)
                            )
                      }
                    </div>`
                      : ''
                  }
                  <span><span>${option.frequency_number} </span>${
                    option.frequency_number == 1 ? 'Month' : 'Months'
                  }</span>
                </div>
              </div>
            `;
            })
            .join('')}
        </div>

        ${
          this.showRecommendations
            ? `<div
                    class="frequency-text"
                    style="
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-around;
                    "
                >
                <span
                    class="frequency-span"
                    data-frequency="2"
                    ${this.isSmall ? 'style="padding-left: 16px;"' : ''}
                >
                    I wash my hair everyday
                </span>
                <span
                    class="frequency-span"
                    data-frequency="3"
                    ${this.isSmall ? 'style="padding-left: 36px;"' : ''}
                >
                    I wash my hair every other day
                </span>
                <span class="frequency-span" data-frequency="4">I wash my hair 1-2 times per week</span>
          </div>`
            : ''
        }
      </div>
    `;
  }

  afterMount() {
    console.log('hey---', this.defaultFrequency);
    this.showFrequencyTextByFrequency(`${this.defaultFrequency}`);
  }

  frequencyObserverCallback(mutationsList) {
    for (let mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'data-selected-frequency'
      ) {
        this.selectedFrequency =
          this.frequencyStateElem.dataset.selectedFrequency;
        this.render();
      }
    }
  }

  handleClick(event) {
    const frequencyButtons =
      this.shadowRoot.querySelectorAll('.frequency-button');
    [...frequencyButtons].forEach((button) => {
      button.classList.remove('selected');
      const divSvg = button.querySelector('#frequency-svg');
      const buttonFrequency = button.getAttribute('data-frequency-number');
      if (divSvg) {
        divSvg.innerHTML = `${frequencyUncheckedSvg(Number(buttonFrequency))}`;
      }
    });
    if (
      event.target.classList.contains('frequency-button') ||
      event.target.parentNode?.classList?.contains('frequency-button')
    ) {
      let frequencyButton;
      if (event.target.classList.contains('frequency-button')) {
        frequencyButton = event.target;
      } else {
        frequencyButton = event.target.parentNode;
      }
      frequencyButton.classList.add('selected');
      const frequencyValue = frequencyButton.dataset.frequencyValue;
      const frequencyNumber = frequencyButton.getAttribute(
        'data-frequency-number'
      );
      const divSvg = frequencyButton.querySelector('#frequency-svg');
      if (divSvg) {
        divSvg.innerHTML = `${frequencyCheckedSvg(Number(frequencyNumber))}`;
      }

      this.showFrequencyTextByFrequency(frequencyNumber);

      const spanFrequencyText =
        this.shadowRoot.querySelector('#frequency-text');
      if (spanFrequencyText) {
        spanFrequencyText.innerHTML = this.frequencyText(frequencyNumber);
      }
      this.updateAllProductsFrequency(frequencyValue);

      if (frequencyValue != this.selectedFrequency) {
        this.enableSaveButtons();
      }

      this.frequencyStateElem.dataset.selectedFrequency =
        frequencyButton.dataset.frequencyNumber;
    }
  }

  updateAllProductsFrequency(value) {
    const all_selling_plans = document.querySelectorAll(
      `select[name=${this.getAttribute('sellingPlansElemName')}]`
    );
    all_selling_plans.forEach((selling_plan) => {
      const option = selling_plan.querySelector(
        `option[data-option-value="${value}"]`
      );
      const selected_value = option?.value;
      if (selected_value) {
        selling_plan.value = selected_value;
      }
    });
  }

  enableSaveButtons() {
    document
      .querySelectorAll(`.${this.getAttribute('saveButtonElemClass')}:disabled`)
      ?.forEach((element) => (element.disabled = false));
  }

  showFrequencyTextByFrequency(frequencyNumber) {
    console.log('8888 this.frequencySpans', this.frequencySpans);
    this.frequencySpans.forEach((span) => {
      console.log('8888 span', span.dataset);
      if (span.dataset.frequency !== frequencyNumber) {
        span.style.visibility = 'hidden';
        return;
      }
      span.style.visibility = 'visible';
    });
  }

  //selling_plan
  get frequencyOptions() {
    const select = document.querySelector(
      `select[name=${this.getAttribute(
        'sellingPlansElemName'
      )}]:not([disabled=disabled])`
    );
    const options = select.querySelectorAll(`option`);

    const isStaging = window.location.hostname.includes('staging');

    if (isStaging) {
      return stagingPlanOptions.filter(
        (x) =>
          !FrequencySelector.EXCLUDE_FREQUENCIES.includes(parseInt(x.value[0]))
      );
    }

    return [...options]
      .filter((option) => {
        return !this.isEditing
          ? !FrequencySelector.EXCLUDE_FREQUENCIES.includes(
              parseInt(option.dataset.optionValue[0])
            )
          : true;
      })
      .map((option) => {
        return {
          selling_plan: option.value,
          value: option.dataset.optionValue,
          frequency_number: option.dataset.optionValue[0]
        };
      });
  }

  frequencyText(frenquecyValue) {
    if (2 === Number(frenquecyValue)) {
      return 'I wash my hair everyday';
    }
    if (3 === Number(frenquecyValue)) {
      return 'I wash my hair every other day';
    }
    if (4 === Number(frenquecyValue)) {
      return 'I wash my hair 1-2 times per week';
    }
  }

  render() {
    return `
      ${Style({ isMobile: this.isSmall })}
      ${FontStyle}
      <div>
          <div class="frequency-buttons-container">
          ${this.frequencyOptions
            .map((option) => {
              return `
              <div
                data-frequency-value="${option.value}"
                data-frequency-number="${option.frequency_number}"
                class="frequency-button
                  ${
                    (this.isEditing &&
                      this.selectedFrequency === option.value) ||
                    (!this.isEditing &&
                      option.frequency_number == this.defaultFrequency)
                      ? 'selected featured-option'
                      : ''
                  }
                "
              >
                ${
                  (this.isEditing && this.selectedFrequency === option.value) ||
                  (!this.isEditing &&
                    option.frequency_number == this.defaultFrequency)
                    ? `<div class="recommended-container recommended-frequency events-none">${this.frequencyLabel}</div>`
                    : ''
                }

                <div class="events-none content-wrapper" ${
                  this.isSmall ? 'style="margin-bottom: 10px"' : ''
                }>
                  ${
                    this.showRecommendations
                      ? `<div id="frequency-svg" class="events-none">
                      ${
                        (this.isEditing &&
                          this.selectedFrequency === option.value) ||
                        (!this.isEditing &&
                          option.frequency_number == this.defaultFrequency)
                          ? frequencyCheckedSvg(Number(option.frequency_number))
                          : frequencyUncheckedSvg(
                              Number(option.frequency_number)
                            )
                      }
                    </div>`
                      : ''
                  }
                  <span><span>${option.frequency_number} </span>${
                    option.frequency_number == 1 ? 'Month' : 'Months'
                  }</span>
                </div>
              </div>
            `;
            })
            .join('')}
        </div>

        ${
          this.showRecommendations
            ? `<div class="frequency-text">
              <span id="frequency-text"> ${this.frequencyText(
                this.defaultFrequency
              )} </span>
          </div>`
            : ''
        }
      </div>
    `;
  }

  get defaultFrequency() {
    const value = this.getAttribute('defaultFrequency');
    if (!value) return FrequencySelector.DEFAULT_FREQUENCY;

    return Number(value);
  }

  get frequencyLabel() {
    const regimenFrequencyLabel = this.getAttribute('regimenFrequencyLabel');
    return regimenFrequencyLabel || 'Most Popular';
  }

  get showRecommendations() {
    return this.getAttribute('show-recommendations') === 'true';
  }

  set showRecommendations(value) {
    this.setAttribute('show-recommendations', `${value}`);
  }

  get frequencySpans() {
    return Array.from(this.shadowRoot.querySelectorAll('.frequency-span'));
  }
}
